import type { Recipe } from '../../types'
import { image } from '../helpers'

export const poolish: Recipe = {
  slug: 'poolish',
  title: 'Pâte à pizza à la poolish',
  category: 'salé',
  description: 'Calculateur de pâte à pizza préparée avec une poolish, avec hydratation et pourcentage de poolish.',
  image: image('poolish'),
  tags: ['pizza', 'poolish', 'fermentation', 'calculateur'],
  meta: [],
  sections: [],
  steps: [],
  special: 'poolish',
}
